import { render, staticRenderFns } from "./OfficeWork.vue?vue&type=template&id=e966bfb6&scoped=true"
import script from "./OfficeWork.vue?vue&type=script&lang=js"
export * from "./OfficeWork.vue?vue&type=script&lang=js"
import style0 from "./OfficeWork.vue?vue&type=style&index=0&id=e966bfb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e966bfb6",
  null
  
)

export default component.exports